<template>
    <div>
        <div class="tabs">
            <button v-for="(tab, index) in tabs" :key="index" :class="{ active: selectedTab === tab }"
                @click="selectedTab = tab">
                {{ tab }}
                <span v-if="countsData" class="count">
                    {{ countsData[index] }}
                </span>
            </button>
        </div>
        <slot :selectedTab="selectedTab"></slot>
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
    name: 'component-tab',
    props: {
        tabs: {
            type: Array,
            required: true,
        },
        initialTab: {
            type: String,
            default: '',
        },
        counts: {
            type: Array,
            required: true,
        }
    },
    setup(props) {
        const countsData = ref(props?.counts ?? 0);
        const selectedTab = ref(props.initialTab || props.tabs[0]);
        return {
            selectedTab,
            countsData
        };
    },
});
</script>